import { render, staticRenderFns } from "./questionBankOfBasicSet.vue?vue&type=template&id=6643a179"
import script from "./questionBankOfBasicSet.vue?vue&type=script&lang=js"
export * from "./questionBankOfBasicSet.vue?vue&type=script&lang=js"
import style0 from "./questionBankOfBasicSet.vue?vue&type=style&index=0&id=6643a179&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports